/* kis-header.js: kop, megamenu, zoeken (desktop en mobiel), mobiele lagen (menu-sheet, zoekscherm) en de USP-strook.
   Structuur overgenomen van INHAND (ih-theme.js), aangepast aan KIS (14-10-2026). Alleen eigen browser-API's.
   Koppelingen: pill (snippets/kis-mobile-pill.liquid) opent lagen via window.KH.open('kh-mnav' | 'kh-msearch');
   elke laag zet 'kh:layer' op document ({ id, open }). Account: assets/kis-account.js ([data-kis-account-open]). */
(() => {
  const KH = (window.KH = window.KH || {});
  const R = KH.routes || { root: '/', suggest: '/search/suggest', search: '/search' };
  const T = Object.assign({
    models: 'Modellen', recent: 'Recent gezocht', popular: 'Populair', bestsellers: 'Bestsellers', products: 'Producten',
    collections: 'Modellen en merken', suggestions: 'Suggesties', allResults: 'Alle resultaten voor "[q]"', enter: 'Enter voor alle resultaten',
    noneTitle: 'Niets gevonden voor "[q]"', noneText: 'Controleer de spelling, of zoek op model, merk of stijlcode.',
    wipe: 'Recente zoekopdrachten wissen', allSneakers: 'Alle sneakers', allSneakersUrl: '/collections/all', from: 'vanaf',
  }, KH.t || {});

  /* Helpers ------------------------------------------------------------------ */
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const icon = (name) => `<svg class="kh-i" aria-hidden="true" focusable="false"><use href="#kh-i-${name}"/></svg>`;
  const imgUrl = (src, w) => { if (!src) return ''; const u = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* privévenster */ } },
  };
  const fill = (tpl, q) => String(tpl || '').replace('[q]', esc(q));
  function money(cents) {
    const fmt = String(KH.moneyFormat || '€{{amount_with_comma_separator}}').replace(/<[^>]+>/g, '');
    const num = (decimals, thousands, decimal) => {
      const parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => ({
      amount: num(2, ',', '.'), amount_no_decimals: num(0, ',', '.'),
      amount_with_comma_separator: num(2, '.', ','), amount_no_decimals_with_comma_separator: num(0, '.', ','),
      amount_with_apostrophe_separator: num(2, "'", '.'),
    }[key] || num(2, '.', ',')));
  }

  /* Lagen (sheets): openen, sluiten, focus vasthouden, wegvegen --------------------------------------- */
  let lastFocus = null;
  const layerEvent = (el, open) => document.dispatchEvent(new CustomEvent('kh:layer', { detail: { id: el.id, open } }));
  function openLayer(el) {
    if (typeof el === 'string') el = document.getElementById(el);
    if (!el) return;
    lastFocus = document.activeElement;
    $$('[data-kh-layer].is-open').forEach((x) => { if (x !== el) closeLayer(x, true); });
    el.classList.add('is-open'); el.removeAttribute('aria-hidden'); document.body.classList.add('kh-lock');
    hydrate(el);
    const field = $('input[type="search"]', el);
    if (field) setTimeout(() => field.focus({ preventScroll: true }), 80); else { const first = $('button[data-kh-close]', el); if (first) setTimeout(() => first.focus({ preventScroll: true }), 60); }
    layerEvent(el, true);
  }
  function closeLayer(el, silent) {
    if (typeof el === 'string') el = document.getElementById(el);
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('[data-kh-layer].is-open')) document.body.classList.remove('kh-lock');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    layerEvent(el, false);
  }
  function trap(e, el) {
    if (e.key !== 'Tab') return;
    const f = $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]', el).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  function initLayers() {
    $$('[data-kh-layer]').forEach((el) => {
      if (el._kh) return; el._kh = true;
      el.setAttribute('aria-hidden', 'true');
      el.addEventListener('click', (e) => { if (e.target.closest('[data-kh-close]')) closeLayer(el); });
      el.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLayer(el); trap(e, el); });
    });
    $$('[data-kh-drag]').forEach((handle) => {
      if (handle._kh) return; handle._kh = true;
      const layer = handle.closest('[data-kh-layer]'); const panel = handle.closest('[data-kh-panel]');
      let y0 = null; let dy = 0;
      handle.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
      handle.addEventListener('touchmove', (e) => { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = `translateY(${dy}px)`; }, { passive: true });
      handle.addEventListener('touchend', () => { panel.style.transition = ''; panel.style.transform = ''; if (dy > 90) closeLayer(layer); y0 = null; });
    });
    if (!document._khOpen) {
      document._khOpen = true;
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-kh-open]'); if (!btn) return;
        e.preventDefault(); openLayer(btn.dataset.khOpen);
      });
    }
  }
  KH.open = openLayer; KH.close = closeLayer;

  /* Menufoto's: bestverkochte product per collectie (templates/collection.kis-first.liquid), productlink: /products/x.js ----- */
  const navImgCache = (() => { try { return JSON.parse(sessionStorage.getItem('kh:navimg') || '{}'); } catch (e) { return {}; } })();
  // Afbeeldingen in verborgen lagen (menu, zoeken) staan als data-src in de HTML en laden pas bij openen (mobiel scheelt ~220 KB bij het eerste laden)
  function hydrate(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('img[data-src]').forEach((img) => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
  }
  function loadNavImages(scope) {
    if (!scope) return;
    hydrate(scope);
    const todo = $$('[data-kh-navimg]', scope).filter((el) => !el._kh); todo.forEach((el) => { el._kh = true; });
    const paint = (el, src) => { if (!src) return; const w = parseInt(el.dataset.khSize, 10) || 160; const img = new Image(); img.alt = ''; img.width = Math.round(w / 2); img.height = Math.round(w / 2); img.decoding = 'async'; img.onload = () => img.classList.add('is-in'); img.src = imgUrl(src, w); el.appendChild(img); };
    const work = async () => {
      while (todo.length) {
        const el = todo.shift(); const url = el.dataset.khNavimg; let src = navImgCache[url];
        if (src === undefined) {
          let ok = true;
          try {
            const u = new URL(url, location.href); let res;
            if (/\/products\/[^/?#]+/.test(u.pathname)) {
              res = await fetch(u.pathname.replace(/\/$/, '') + '.js'); if (!res.ok) throw new Error(res.status);
              const p = await res.json(); src = p.featured_image || (p.images && p.images[0]) || '';
            } else {
              u.searchParams.set('view', 'kis-first'); u.searchParams.set('sort_by', 'best-selling'); res = await fetch(u.toString()); if (!res.ok) throw new Error(res.status);
              const data = JSON.parse((await res.text()).trim()); src = data.image || '';
            }
          } catch (e) { src = ''; ok = false; }
          // alleen een geslaagd antwoord onthouden; na een mislukking (bijv. te veel verzoeken) probeert het menu de volgende keer opnieuw
          if (ok) { navImgCache[url] = src; try { sessionStorage.setItem('kh:navimg', JSON.stringify(navImgCache)); } catch (e) { /* privévenster */ } } else { el._kh = false; }
        }
        paint(el, src);
      }
    };
    for (let i = 0; i < 4; i += 1) work();
  }
  KH.loadNavImages = loadNavImages;

  /* Megamenu (desktop) ------------------------------------------------------------------------------- */
  function initNav() {
    const nav = $('[data-kh-nav]'); if (!nav || nav._kh) return; nav._kh = true;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)'); let openItem = null; let timer = null;
    const parts = (item) => ({ top: $('[data-kh-navtop]', item), mega: $('[data-kh-mega]', item) });
    const close = (item) => { if (!item) return; const { top, mega } = parts(item); top.setAttribute('aria-expanded', 'false'); mega.classList.remove('is-open'); clearTimeout(mega._t); mega._t = setTimeout(() => { mega.hidden = true; }, 220); if (openItem === item) openItem = null; document.body.classList.toggle('kh-mega-open', !!openItem); };
    const open = (item) => {
      if (openItem === item) return; close(openItem); const { top, mega } = parts(item); clearTimeout(mega._t); mega.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => mega.classList.add('is-open'))); top.setAttribute('aria-expanded', 'true'); openItem = item; document.body.classList.add('kh-mega-open');
      const split = $('[data-kh-megasplit]', mega);
      if (split) { loadNavImages($('.kh-mega__side', split)); const first = $('[data-kh-megago][aria-expanded="true"]', split) || $('[data-kh-megago]', split); if (first) pane(first); } else loadNavImages(mega);
    };
    // diep menu: het merk waar je op staat toont rechts zijn modellen
    function pane(cell) {
      const split = cell.closest('[data-kh-megasplit]'); if (!split) return;
      $$('[data-kh-megago]', split).forEach((c) => c.setAttribute('aria-expanded', String(c === cell)));
      $$('[data-kh-megapane]', split).forEach((p) => { p.hidden = p.id !== cell.dataset.khMegago; });
      loadNavImages(document.getElementById(cell.dataset.khMegago));
    }
    $$('[data-kh-megago]', nav).forEach((cell) => {
      cell.addEventListener('mouseenter', () => { if (fine.matches) pane(cell); });
      cell.addEventListener('focus', () => pane(cell));
      cell.addEventListener('click', (e) => { if (cell.getAttribute('aria-expanded') !== 'true') { e.preventDefault(); pane(cell); } });
    });
    $$('[data-kh-navitem]', nav).forEach((item) => {
      item.addEventListener('mouseenter', () => { if (!fine.matches) return; clearTimeout(timer); timer = setTimeout(() => open(item), 90); });
      item.addEventListener('mouseleave', () => { if (!fine.matches) return; clearTimeout(timer); timer = setTimeout(() => close(item), 260); });
      // aanraken of toetsenbord: de eerste tik opent het paneel, de tweede volgt de link
      parts(item).top.addEventListener('click', (e) => { if (openItem !== item) { e.preventDefault(); clearTimeout(timer); open(item); } });
      item.addEventListener('focusout', (e) => { if (e.relatedTarget && !item.contains(e.relatedTarget)) close(item); });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openItem) { const { top } = parts(openItem); close(openItem); top.focus(); } });
    document.addEventListener('click', (e) => { if (openItem && !openItem.contains(e.target)) close(openItem); });
    // Voor het nalopen van het ontwerp: ?khmenu=1 opent het eerste menu-paneel direct (2 = het tweede, enz.)
    const qa = new URLSearchParams(location.search); if (qa.has('khmenu')) { const it = $$('[data-kh-navitem]', nav)[(parseInt(qa.get('khmenu'), 10) || 1) - 1]; if (it) open(it); }
  }

  /* Mobiel menu (sheet met panelen) ------------------------------------------------------------------ */
  function initMnav() {
    const root = $('[data-kh-mnav]'); if (!root || root._kh) return; root._kh = true;
    const sheet = root.closest('[data-kh-layer]');
    const show = (id) => {
      $$('[data-panel]', root).forEach((p) => { p.hidden = p.dataset.panel !== id; });
      if (sheet) $$('[data-kh-mnav-extra]', sheet).forEach((x) => { x.hidden = id !== 'root'; });
      const body = root.closest('.kh-sheet__body'); if (body) body.scrollTop = 0;
      const active = $(`[data-panel="${id}"]`, root); loadNavImages(active);
      if (id !== 'root') { const first = $('button, a', active); if (first) first.focus({ preventScroll: true }); }
    };
    root.addEventListener('click', (e) => {
      const go = e.target.closest('[data-kh-mnav-go]'); if (go) { e.preventDefault(); show(go.dataset.khMnavGo); return; }
      const back = e.target.closest('[data-kh-mnav-back]'); if (back) show(back.dataset.khMnavBack);
    });
    if (sheet) new MutationObserver(() => { if (sheet.classList.contains('is-open')) { loadNavImages($('[data-panel]:not([hidden])', root)); $$('[data-kh-mnav-extra]', sheet).forEach((x) => loadNavImages(x)); } else show('root'); }).observe(sheet, { attributes: true, attributeFilter: ['class'] });
  }

  /* Zoeken ------------------------------------------------------------------------------------------- */
  const FIELD_RE = /^(title|vendor|product_type|tag|sku|barcode|variants\.title):/i;
  const searchWords = (q) => [...new Set((q || '').replace(/[()"':*]/g, ' ').replace(/\bOR\b/g, ' ').split(/\s+/).filter(Boolean).filter((w) => !FIELD_RE.test(w)))];
  const searchHref = (q) => `${R.search}?type=product&q=${encodeURIComponent(searchWords(q).join(' '))}`;
  async function suggest(q, full) {
    const types = full ? 'product,collection,query' : 'product';
    const url = `${R.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=${types}&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
    const r = await fetch(url, { headers: { Accept: 'application/json' } }); const j = await r.json();
    const res = ((j.resources || {}).results) || {};
    return { products: res.products || [], collections: res.collections || [], queries: res.queries || [] };
  }
  const markHTML = (text, q) => {
    const t = String(text || ''); const words = (q || '').trim().split(/\s+/).filter((w) => w.length > 1).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    if (!words.length) return esc(t);
    const re = new RegExp('(' + words.join('|') + ')', 'ig');
    return t.split(re).map((part, i) => (i % 2 ? `<mark>${esc(part)}</mark>` : esc(part))).join('');
  };
  const hitHTML = (p, q) => {
    const img = (p.featured_image && p.featured_image.url) || p.image || '';
    const cents = Math.round(parseFloat(p.price_min || p.price || 0) * 100);
    const varies = p.price_min && p.price_max && p.price_min !== p.price_max;
    return `<a class="kh-search__tile" href="${esc(p.url)}" data-kh-opt role="option"><span class="kh-search__pic">${img ? `<img src="${esc(imgUrl(img, 360))}" alt="" width="180" height="180" loading="lazy">` : ''}</span><span class="kh-search__meta"><strong>${markHTML(p.title, q)}</strong><span class="kh-search__price">${varies ? esc(T.from) + ' ' : ''}${money(cents)}</span></span></a>`;
  };
  const idleCache = {};
  async function idleProducts(handle) {
    if (!handle) return [];
    if (idleCache[handle]) return idleCache[handle];
    try { const c = sessionStorage.getItem('kh:idle:' + handle); if (c) { idleCache[handle] = JSON.parse(c); return idleCache[handle]; } } catch (e) { /* privévenster */ }
    try {
      const r = await fetch(`${R.root.replace(/\/$/, '')}/collections/${handle}/products.json?limit=24`, { headers: { Accept: 'application/json' } }); const j = await r.json();
      const list = (j.products || []).filter((p) => (p.variants || []).some((v) => v.available) && p.images && p.images.length).slice(0, 8).map((p) => {
        const prices = p.variants.filter((v) => v.available).map((v) => parseFloat(v.price));
        return { url: `${R.root.replace(/\/$/, '')}/products/${p.handle}`, title: p.title, vendor: p.vendor, featured_image: { url: p.images[0].src }, price_min: String(Math.min(...prices)), price_max: String(Math.max(...prices)) };
      });
      idleCache[handle] = list; try { sessionStorage.setItem('kh:idle:' + handle, JSON.stringify(list)); } catch (e) { /* stil */ }
      return list;
    } catch (e) { return []; }
  }
  const Recent = {
    list: () => (store.get('kh:recent', []) || []).filter((x) => typeof x === 'string').slice(0, 6),
    add(q) { const v = (q || '').trim(); if (!v) return; const list = Recent.list().filter((x) => x.toLowerCase() !== v.toLowerCase()); list.unshift(v); store.set('kh:recent', list.slice(0, 6)); },
    clear() { store.set('kh:recent', []); },
  };
  const searchChip = (q) => `<a class="kh-search__chip" href="${esc(R.search)}?q=${encodeURIComponent(q)}&type=product" data-kh-opt data-q="${esc(q)}" role="option">${esc(q)}</a>`;
  function searchIdleHTML(form) {
    const popular = (form.dataset.popular || '').split(',').map((x) => x.trim()).filter(Boolean); const recent = Recent.list();
    const tpl = form.querySelector('template[data-kh-search-models]'); const models = tpl ? tpl.innerHTML.trim() : '';
    let side = '';
    if (models) side += `<span class="kh-search__label kh-mono">${esc(T.models)}</span><div class="kh-search__models">${models}</div>`;
    if (recent.length) side += `<span class="kh-search__label kh-mono">${esc(T.recent)}</span><div class="kh-search__chips">${recent.map(searchChip).join('')}</div>`;
    if (!models && popular.length) side += `<span class="kh-search__label kh-mono">${esc(T.popular)}</span><div class="kh-search__chips">${popular.map(searchChip).join('')}</div>`;
    const grid = form.dataset.idle ? `<div class="kh-search__col kh-search__col--grid" data-kh-search-idle hidden></div>` : '';
    if (!side && !grid) return '';
    const sideCol = side ? `<div class="kh-search__col kh-search__col--side">${side}</div>` : '';
    const body = sideCol && grid ? `<div class="kh-search__cols">${sideCol}${grid}</div>` : (sideCol || grid);
    return body + (recent.length ? `<div class="kh-search__foot"><span></span><button type="button" class="kh-search__wipe" data-kh-search-wipe>${esc(T.wipe)}</button></div>` : '');
  }
  async function fillIdle(panel, handle) {
    const slot = $('[data-kh-search-idle]', panel); if (!slot) return;
    const list = await idleProducts(handle); const still = $('[data-kh-search-idle]', panel); if (!still) return;
    if (!list.length) { still.remove(); return; }
    still.innerHTML = `<span class="kh-search__label kh-mono">${esc(T.bestsellers)}</span><div class="kh-search__grid">${list.map((p) => hitHTML(p, '')).join('')}</div>`; still.hidden = false;
  }
  function searchResultsHTML(res, q) {
    const { products, collections, queries } = res;
    if (!products.length && !collections.length && !queries.length) {
      return `<div class="kh-search__empty"><strong>${fill(T.noneTitle, q)}</strong>${esc(T.noneText)}</div><div class="kh-search__foot"><span></span><a class="kh-search__chip" href="${esc(T.allSneakersUrl)}" data-kh-opt role="option">${esc(T.allSneakers)}</a></div>`;
    }
    let side = '';
    if (collections.length) side += `<span class="kh-search__label kh-mono">${esc(T.collections)}</span>` + collections.slice(0, 6).map((c) => `<a class="kh-search__row" href="${esc(c.url)}" data-kh-opt role="option">${icon('chev-r')}<span>${markHTML(c.title, q)}</span></a>`).join('');
    if (queries.length) side += `<span class="kh-search__label kh-mono">${esc(T.suggestions)}</span>` + queries.slice(0, 4).map((s) => `<a class="kh-search__row" href="${esc(s.url)}" data-kh-opt data-q="${esc(s.text)}" role="option">${icon('search')}<span>${markHTML(s.text, q)}</span></a>`).join('');
    const sideCol = side ? `<div class="kh-search__col kh-search__col--side">${side}</div>` : '';
    const grid = products.length ? `<div class="kh-search__col kh-search__col--grid"><span class="kh-search__label kh-mono">${esc(T.products)}</span><div class="kh-search__grid">${products.slice(0, 8).map((p) => hitHTML(p, q)).join('')}</div></div>` : '';
    const body = sideCol && grid ? `<div class="kh-search__cols">${sideCol}${grid}</div>` : (grid || sideCol);
    return body + `<div class="kh-search__foot"><span class="kh-search__hint kh-mono">${esc(T.enter)}</span><button type="submit" class="kh-btn kh-btn--primary" data-kh-opt role="option">${fill(T.allResults, q)}</button></div>`;
  }
  function initSearch() {
    const form = $('[data-kh-search]');
    if (form && !form._kh) {
      form._kh = true;
      const input = $('input[type="search"]', form); const panel = $('[data-kh-search-panel]', form); const clear = $('[data-kh-search-clear]', form);
      const wrap = form.closest('.shopify-section') || form.closest('.kh-header') || form.parentElement;
      // Chrome scrolt bij focus of typen in een veld binnen een plakkende kop naar de oorspronkelijke plek van dat veld.
      // Zolang het zoekveld actief is zetten we de kop daarom vast (position: fixed) op de plek waar hij nu staat, met een vulblok.
      let spacer = null; let staticTop = 0;
      const pin = () => {
        if (wrap._khPinned) return; const r = wrap.getBoundingClientRect(); wrap._khPinned = true;
        if (!spacer) { spacer = document.createElement('div'); spacer.setAttribute('aria-hidden', 'true'); }
        spacer.style.height = r.height + 'px'; wrap.parentNode.insertBefore(spacer, wrap); staticTop = spacer.getBoundingClientRect().top + window.scrollY;
        Object.assign(wrap.style, { position: 'fixed', top: r.top + 'px', left: '0', right: '0', width: 'auto' });
      };
      const unpin = () => { if (!wrap._khPinned) return; wrap._khPinned = false; ['position', 'top', 'left', 'right', 'width'].forEach((k) => { wrap.style[k] = ''; }); if (spacer && spacer.parentNode) spacer.remove(); };
      window.addEventListener('scroll', () => { if (wrap._khPinned) wrap.style.top = Math.max(0, staticTop - window.scrollY) + 'px'; }, { passive: true });

      let seq = 0; let timer = null; let active = -1;
      const opts = () => $$('[data-kh-opt]', panel);
      const setActive = (i) => {
        const list = opts(); active = list.length ? ((i % list.length) + list.length) % list.length : -1;
        list.forEach((el, k) => { el.classList.toggle('is-active', k === active); });
        const el = list[active];
        if (el) { if (!el.id) el.id = 'kh-sopt-' + active; input.setAttribute('aria-activedescendant', el.id); const pr = panel.getBoundingClientRect(); const er = el.getBoundingClientRect(); if (er.top < pr.top) panel.scrollTop -= pr.top - er.top; else if (er.bottom > pr.bottom) panel.scrollTop += er.bottom - pr.bottom; }
        else input.removeAttribute('aria-activedescendant');
      };
      const open = (html) => {
        const was = panel.hidden ? 0 : panel.offsetHeight;
        panel.innerHTML = html; panel.hidden = !html; form.classList.toggle('is-open', !!html); input.setAttribute('aria-expanded', String(!!html)); active = -1; input.removeAttribute('aria-activedescendant');
        if (html && was) { panel.style.minHeight = was + 'px'; requestAnimationFrame(() => { panel.style.minHeight = Math.min(panel.scrollHeight, panel.clientHeight) + 'px'; clearTimeout(panel._khMh); panel._khMh = setTimeout(() => { panel.style.minHeight = ''; }, 260); }); }
      };
      const close = () => { panel.hidden = true; panel.innerHTML = ''; form.classList.remove('is-open', 'is-loading'); input.setAttribute('aria-expanded', 'false'); active = -1; };
      const run = () => {
        const q = input.value.trim(); clear.hidden = !input.value; clearTimeout(timer);
        if (q.length < 2) { form.classList.remove('is-loading'); open(searchIdleHTML(form)); loadNavImages(panel); fillIdle(panel, form.dataset.idle); return; }
        form.classList.add('is-loading');
        timer = setTimeout(async () => {
          const mine = ++seq;
          try { const res = await suggest(q, true); if (mine !== seq) return; form.classList.remove('is-loading'); open(searchResultsHTML(res, q)); }
          catch (e) { if (mine === seq) { form.classList.remove('is-loading'); open(searchResultsHTML({ products: [], collections: [], queries: [] }, q)); } }
        }, 140);
      };
      input.addEventListener('pointerdown', pin);
      input.addEventListener('focus', () => { pin(); if (panel.hidden) run(); });
      input.addEventListener('input', run);
      clear.addEventListener('click', () => { input.value = ''; clear.hidden = true; input.focus(); run(); });
      form.addEventListener('submit', (e) => { const q = input.value.trim(); e.preventDefault(); if (!q) { input.focus(); return; } Recent.add(q); location.assign(searchHref(q)); });
      panel.addEventListener('mousedown', (e) => { if (e.target.closest('[data-kh-opt], [data-kh-search-wipe]')) e.preventDefault(); });
      panel.addEventListener('click', (e) => {
        if (e.target.closest('[data-kh-search-wipe]')) { Recent.clear(); open(searchIdleHTML(form)); loadNavImages(panel); fillIdle(panel, form.dataset.idle); input.focus(); return; }
        const opt = e.target.closest('a[data-kh-opt]'); if (opt) Recent.add(opt.dataset.q != null ? opt.dataset.q : input.value);
      });
      form.addEventListener('focusout', (e) => { if (e.relatedTarget && form.contains(e.relatedTarget)) return; setTimeout(() => { if (!form.contains(document.activeElement)) { close(); unpin(); } }, 0); });
      document.addEventListener('click', (e) => { if (!form.contains(e.target)) { close(); if (document.activeElement !== input) unpin(); } });
      form.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { if (panel.hidden) { run(); return; } e.preventDefault(); setActive(active + (e.key === 'ArrowDown' ? 1 : -1)); return; }
        if (e.key === 'Enter') { const list = opts(); if (active > -1 && list[active]) { e.preventDefault(); list[active].click(); } return; }
        if (e.key === 'Escape') { e.preventDefault(); if (input.value) { input.value = ''; run(); } else { close(); input.blur(); unpin(); } return; }
        if (e.key === 'Tab') close();
      });
    }
    const m = $('[data-kh-msearch]');
    if (m && !m._kh) {
      m._kh = true; const input = $('input[type="search"]', m); const idle = $('[data-kh-msearch-idle]'); const results = $('[data-kh-msearch-results]');
      let timer = null; let seq = 0;
      input.addEventListener('input', () => {
        clearTimeout(timer); const q = input.value.trim();
        if (q.length < 2) { if (idle) idle.hidden = false; results.hidden = true; return; }
        timer = setTimeout(async () => {
          const mine = ++seq;
          try { const res = await suggest(q, false); if (mine !== seq) return; if (idle) idle.hidden = true; results.hidden = false; results.innerHTML = res.products.length ? `<div class="kh-search__grid kh-search__grid--m">${res.products.map((p) => hitHTML(p, q)).join('')}</div>` : `<p class="kh-search__empty"><strong>${fill(T.noneTitle, q)}</strong>${esc(T.noneText)}</p>`; }
          catch (e) { /* stil */ }
        }, 160);
      });
      m.addEventListener('submit', (e) => { const q = input.value.trim(); e.preventDefault(); if (!q) return; Recent.add(q); location.assign(searchHref(q)); });
      document.addEventListener('kh:layer', (e) => { if (e.detail && e.detail.id === 'kh-msearch' && e.detail.open) loadNavImages($('#kh-msearch')); });
      const chips = $('[data-kh-msearch-chips]');
      if (chips) chips.addEventListener('click', (e) => { const b = e.target.closest('[data-q]'); if (!b) return; input.value = b.dataset.q; input.dispatchEvent(new Event('input')); });
      const scroller = $('#kh-msearch .kh-sheet__body'); if (scroller) scroller.addEventListener('touchmove', () => input.blur(), { passive: true });
    }
  }

  /* USP-strook in de aankondigingsbalk ----------------------------------------------------------------- */
  function initTicker() {
    $$('[data-kh-ticker]').forEach((t) => {
      if (t._kh) return; t._kh = true;
      const groups = $$('.kh-announce__group', t); const base = groups[0] && groups[0].firstElementChild; if (!base || groups.length < 2) return;
      const set = () => {
        const w = base.getBoundingClientRect().width; const vis = t.clientWidth; if (!w || !vis) return;
        const px = parseFloat(t.style.getPropertyValue('--kh-ticker-px')) || 40;
        const need = Math.max(1, Math.ceil(vis / w));
        groups.forEach((g) => {
          while (g.children.length < need) { const c = base.cloneNode(true); c.setAttribute('aria-hidden', 'true'); g.appendChild(c); }
          while (g.children.length > need) g.lastElementChild.remove();
        });
        t.style.setProperty('--kh-ticker-s', Math.max(8, Math.round((w * need) / px)) + 's');
      };
      set(); window.addEventListener('resize', set); if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
    });
  }

  /* Mobiele wisselbalk (Luc 23 okt): één regel tegelijk, wisselt elke paar seconden; desktop toont de lopende strook ------------- */
  function initRotor() {
    $$('[data-kh-rotor]').forEach((r) => {
      if (r._kh) return; r._kh = true;
      const slides = $$('.kh-announce__slide', r); if (slides.length < 2) return;
      const ms = Math.max(1500, parseInt(r.dataset.khRotorMs, 10) || 3000); let i = 0;
      window.setInterval(() => {
        if (document.hidden || getComputedStyle(r).display === 'none') return;
        slides[i].classList.remove('is-active'); i = (i + 1) % slides.length; slides[i].classList.add('is-active');
      }, ms);
    });
  }

  /* T-Lab taalwisselaar (app-embed): de vlag vóór het account-icoon (desktop) en vóór .kis-header__search-modal (mobiel) ------ */
  function initTlab() {
    let tries = 0;
    const mount = () => {
      const TL = window.TranslationLab; const opts = TL && TL.switcherOptions;
      if (!TL || !TL.Switcher || typeof TL.Switcher.configure !== 'function' || !opts) { if (tries++ < 40) window.setTimeout(mount, 250); return; }
      if (opts.switcherPosition !== 'header') return;
      if (opts.headerRefElement || opts.mobileRefElement) return;
      if ($('.kh-header .tl-switcher-container')) return;
      TL.Switcher.configure(Object.assign({}, opts, { headerRefElement: '.kis-header__account', headerRelativePosition: 'before', mobileRefElement: '.kis-header__search-modal', mobileRelativePosition: 'before' }));
    };
    mount();
  }

  /* Zwevende kop (26 okt 2026, Luc: zoals Histrips): de kopgroep verdwijnt bij omlaag scrollen en komt terug bij omhoog scrollen.
     Niet verbergen zolang een laag (menu/zoeken/mega) open staat of de kop door het zoekveld is vastgezet (pin). */
  function initAutoHide() {
    const wrap = $('.kh-header-wrap'); if (!wrap || wrap._khAuto) return; wrap._khAuto = true;
    const announce = (() => { const a = $('.kh-announce'); return a ? (a.closest('.shopify-section') || a) : null; })();
    const parent = wrap.parentElement;
    // Eén groepsomhulsel (als Shopify dat rendert) of anders de twee secties los: beide plakken en schuiven samen weg
    const group = parent && parent !== document.body && announce && parent.contains(announce) && parent.children.length <= 3 ? [parent] : [announce, wrap].filter(Boolean);
    group.forEach((el) => el.classList.add('kh-group'));
    const stick = () => { wrap.style.setProperty('--kh-stick', group.length > 1 && announce ? announce.offsetHeight + 'px' : '0px'); };
    stick(); window.addEventListener('resize', stick, { passive: true });
    let last = window.scrollY; let ticking = false;
    const toggle = (on) => group.forEach((el) => el.classList.toggle('kh-group--hidden', on));
    const busy = () => wrap._khPinned || document.querySelector('.kh-sheet.is-open, .kh-search.is-open, .kh-header [aria-expanded="true"]');
    const mq = window.matchMedia('(max-width: 989px)'); // alleen op mobiel; desktop houdt de vaste kop
    const update = () => {
      ticking = false;
      const y = window.scrollY; const dy = y - last; last = y;
      if (!mq.matches || y < 24 || busy()) { toggle(false); return; }
      if (dy > 4 && y > 140) toggle(true);
      else if (dy < -4) toggle(false);
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  }

  function boot() {
    [initLayers, initNav, initMnav, initSearch, initTicker, initRotor, initTlab, initAutoHide].forEach((step) => { try { step(); } catch (err) { if (window.console) console.error('[KIS header]', err); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
